export default __webpack_public_path__ + "static/media/services.ee6ec747.png";